import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SolidPadlockIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 34,
  height = 34,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g data-testid="icon-solid-padlock" fill="none" height="16" width="13">
        <path
          clipRule="evenodd"
          d="M10.3277 4.5C11.5274 4.5 12.5 5.49006 12.5 6.71134V13.2887C12.5 14.5099 11.5274 15.5 10.3277 15.5H2.17186C0.972113 15.5 0 14.5099 0 13.2887V6.71134C0 5.49006 0.972113 4.5 2.17186 4.5H10.3277ZM6.25 7.5C5.28356 7.5 4.5 8.30469 4.5 9.2972C4.5 10.0322 4.93069 10.6623 5.54574 10.9407V12.2676C5.54574 12.6722 5.86491 13 6.25892 13C6.65293 13 6.9721 12.6722 6.9721 12.2676V10.93C7.57724 10.6475 8 10.0245 8 9.2972C8 8.30469 7.21644 7.5 6.25 7.5Z"
          fill="#000000"
          className={styles.defaultColor}
          fillRule="evenodd"
        />
        <path
          d="M6.25 0C4.1069 0 2.375 1.81174 2.375 4.04007V5.625L2.37857 5.69051C2.41561 6.01124 2.68193 6.25 3 6.25C3.34518 6.25 3.625 5.97018 3.625 5.625V4.04007L3.62698 3.93014C3.68028 2.43496 4.84167 1.25 6.25 1.25C7.69622 1.25 8.875 2.49619 8.875 4.04007V5.625L8.87857 5.69051C8.91561 6.01124 9.18193 6.25 9.5 6.25C9.84518 6.25 10.125 5.97018 10.125 5.625V4.04007L10.1231 3.91423C10.0582 1.73771 8.34765 0 6.25 0Z"
          fill="#000000"
          className={styles.defaultColor}
        />
      </g>
    </Icon>
  )
}
